import { render } from "./EmbedPosition.vue?vue&type=template&id=f0b0afba&scoped=true"
import script from "./EmbedPosition.vue?vue&type=script&lang=ts"
export * from "./EmbedPosition.vue?vue&type=script&lang=ts"

import "./EmbedPosition.vue?vue&type=style&index=0&id=f0b0afba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f0b0afba"

export default script